// frontend/src/components/mcbim/RoomColoringResultChart.tsx
import React from "react";
import { Card, Stack, Text, Group, Box, Divider, Flex, ActionIcon, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectActiveRoomColoring } from "../Room/roomSelectors";
import { RoomColoringPieChart } from "./RoomColoringPieChart";
import { RoomColoringTrendChart } from "./RoomColoringTrendChart";
import { selectTrendByKeyArgsForRoomColoring } from "./roomColoringSelectors";

export const RoomColoringResultChart: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const activeRoomColoring = useAppSelector(selectActiveRoomColoring);
  const roomColoringTrendAvailable = useAppSelector(selectTrendByKeyArgsForRoomColoring);


  if (!activeRoomColoring) {
    return (
      <Card withBorder radius="sm" p="xs">
        <Text size="xs" c="dimmed">
          Ingen romfargelegging er aktiv.
        </Text>
      </Card>
    );
  }

  return (
    <Card
      withBorder
      radius="sm"
      p="xs"
      style={{
        background: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(6px)",
        ...style,
      }}
    >
      {/* ✅ Important: make Stack fill card and allow children to flex */}
      <Stack h="100%" style={{ minHeight: 0 }} gap={6}>
        <Group justify="space-between" align="center" wrap="nowrap" style={{ flexShrink: 0 }}>
          <Text size="sm" fw={600} truncate style={{ minWidth: 0 }}>
            {activeRoomColoring.title}
          </Text>

          {/* <Tooltip label={showLarge ? "Vis mindre" : "Vis større"} withArrow>
            <ActionIcon
              size="sm"
              variant="subtle"
              color="gray"
              onClick={() => dispatch(setShowRoomColoringLargeInRedux(!showLarge))}
              aria-label={showLarge ? "Vis mindre" : "Vis større"}
            >
              {showLarge ? <FiMinimize2 size={16} /> : <FiMaximize2 size={16} />}
            </ActionIcon>
          </Tooltip> */}
        </Group>

        {/* ✅ Divider should not steal flex height */}
        <Divider style={{ flexShrink: 0 }} />

        {/* ✅ THIS wrapper must be flex:1 (not just the Flex component) */}
        <Box style={{ flex: 1, minHeight: 0 }}>
          <Flex h="100%" gap="md" align="stretch">
            <Box style={{ flex: 1, minWidth: 0, minHeight: 0 }}>
              <RoomColoringPieChart />
            </Box>

            {roomColoringTrendAvailable && (
              <Box style={{ flex: 1, minWidth: 0, minHeight: 0 }}>
                <RoomColoringTrendChart />
              </Box>
            )}
          </Flex>
        </Box>
      </Stack>
    </Card>
  );
};
